export default __webpack_public_path__ + "static/media/Symphony Nr 10.6f2f5bc6.png";